import Entity from './entity'
import QuestionTplDet from './questiontpldet'
export default class QuestionTpl extends Entity<number>{
	id:number;
    name:string;
	desc:string;
	luckDrawTplId:number;
	luckDrawTpl:object;
	pic:string;
	questionType:number;
	point:number;
	lotteryCount:number;
	isContainsExternal:number;
	orgId:Array<object>;
	status:string;
	startTime:Date;
	endTime:Date;
	voteCount:number;
	voteDayCount:number;
	questionUserName:string;
	questionTplDetList:Array<QuestionTplDet>;
	
	isAppHomePrompt:boolean;
	isVerifyAnswer:boolean;
	isShowError:boolean;
	users:Array<object>;
	organizations:Array<object>;
	createUser:object;
}